<template>
  <a-drawer width="80%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item :label="$t('videoTag.tagTitleIn')" prop="tagTitleIn" >
        <a-input v-model="form.tagTitleIn" :placeholder="$t('videoTag.inputTagTitleIn')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('videoTag.tagTitleEn')" prop="tagTitleEn" >
        <a-input v-model="form.tagTitleEn" :placeholder="$t('videoTag.inputTagTitleEn')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('videoTag.tagTitleCn')" prop="tagTitleCn" >
        <a-input v-model="form.tagTitleCn" :placeholder="$t('videoTag.inputTagTitleCn')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('videoTag.tagTitle')" prop="tagTitle" >
        <a-input v-model="form.tagTitle" :placeholder="$t('videoTag.inputTagTitle')" />
      </a-form-model-item>

<!--      <a-form-model-item label="标题名称(西班牙语)" prop="tagTitleBm" >-->
<!--        <a-input v-model="form.tagTitleBm" placeholder="请输入标题名称(西班牙语)" />-->
<!--      </a-form-model-item>-->



      <a-form-model-item :label="$t('videoTag.sortLabel')" prop="sort" >
        <a-input-number :min="0" style="width: 100%;" :precision="0" v-model="form.sort" :placeholder="$t('videoTag.inputSort')" />
      </a-form-model-item>


<!--      <a-form-model-item label="背景图" prop="imgUrl" >-->
<!--        <a-upload-->
<!--          listType="picture-card"-->
<!--          class="avatar-uploader"-->
<!--          v-model="form.imgUrl"-->
<!--          :showUploadList="false"-->
<!-- removed old yourstc upload url -->
<!--          :beforeUpload="beforeUpload"-->
<!--          :customRequest="handleChange"-->
<!--        >-->
<!--          <div v-if="form.imgUrl" class="upload-image-wrapper">-->
<!--            <img-->
<!--              :src="form.imgUrl"-->
<!--              alt="logo"-->
<!--              style="height:104px;max-width:300px"/>-->
<!--            <div v-if="uploadLoading" class="upload-mask">-->
<!--              <a-icon type="loading" style="font-size: 24px; color: #1890ff;"/>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div v-else>-->
<!--            <a-icon :type="uploadLoading ? 'loading' : 'plus'"/>-->
<!--            <div class="ant-upload-text">上传</div>-->
<!--          </div>-->
<!--        </a-upload>-->
<!--      </a-form-model-item>-->
      <!--      <a-form-model-item style="display: flex" label="颜色" prop="colors" >-->
      <!--        <el-color-picker style="margin-left: 100%"  v-model="form.colors" />-->
      <!--      </a-form-model-item>-->
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('common.save') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('common.cancel') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getTag, addTag, updateTag } from '@/api/video/tag'
import elColorPicker from 'el-color-picker'
import UploadFileToVOD from '@/api/vod.js'
import UploadFileToOSS from "@/utils/upload-file-to-oss";
export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    elColorPicker
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      uploadLoading: false,
      // 表单参数
      form: {
        id: null,

        tagTitle: null,

        tagTitleEn: null,
        tagTitleCn: null,
        sort: null,
        tagTitleBm: null,
        tagTitleIn: null,
        imgUrl: null,

        colors: null,

        createTime: null,

        remark: null

      },
      // 1增加,2修改
      formType: 1,
      open: false
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    rules() {
      return {
        tagTitle: [
          { required: true, message: this.$t('videoTag.tagTitleRequired'), trigger: 'blur' }
        ],
        tagTitleEn: [
          { required: true, message: this.$t('videoTag.tagTitleEnRequired'), trigger: 'blur' }
        ],
        tagTitleCn: [
          { required: true, message: this.$t('videoTag.tagTitleCnRequired'), trigger: 'blur' }
        ],
        tagTitleBm: [
          { required: true, message: this.$t('videoTag.tagTitleBmRequired'), trigger: 'blur' }
        ],
        tagTitleIn: [
          { required: true, message: this.$t('videoTag.tagTitleInRequired'), trigger: 'blur' }
        ],
        imgUrl: [
          { required: false, message: this.$t('videoTag.uploadBackground'), trigger: 'change' }
        ],
        colors: [
          { required: true, message: this.$t('videoTag.selectColor') }
        ]
      }
    }
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.form = {
             id: null,

            tagTitle: null,

            tagTitleEn: null,
        tagTitleCn: null,
        tagTitleBm: null,
        tagTitleIn: null,
        sort: null,
        imgUrl: null,

            colors: null,

            createTime: null,

            remark: null

      }
    },

    handleChange(info) {
      const that = this
      that.uploadLoading = true
      debugger
      new UploadFileToVOD([info.file], {
        success: function (fileName) {
          that.form.imgUrl = fileName[0]// 文件名
          that.uploadLoading = false
          // 清除该字段的验证错误
          that.$nextTick(() => {
            if (that.$refs.form) {
              that.$refs.form.clearValidate('imgUrl')
            }
          })
        },
        error: function () {
          that.uploadLoading = false
          that.$message.error(that.$t('videoTag.uploadFailed'))
        }
      })
    },
    beforeUpload: function (file) {
      var fileType = file.type
      if (fileType.indexOf('image') < 0) {
        this.$message.warning(this.$t('videoTag.uploadImage'))
        this.uploadLoading = false
        return false
      }
      this.form.imgUrl = ''
      this.uploadLoading = true
      // TODO 驗證文件大小
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        tagTitle: null,
        tagTitleEn: null,
        tagTitleCn: null,
        tagTitleBm: null,
        tagTitleIn: null,
        sort: null,
        imgUrl: null,
        colors: null,
        createTime: null,
        remark: null
      }
      // this.$nextTick(() => {
      //   if(this.$refs.form){
      //     this.$refs.form.resetFields()
      //   }
      // })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('common.add')
      this.form.colors = ''
      this.form.tagTitle = ''
      // this.form={
      //   id: null,
      //
      //   tagTitle: null,
      //
      //   colors: null,
      //
      //   createTime: null,
      //
      //   remark: null,
      //
      // }
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getTag({ 'id': id }).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('common.edit')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateTag(this.form).then(response => {
              this.$message.success(
                this.$t('common.updateSuccess'),
                3
              )
              this.open = false
              this.$emit('ok')
              this.form = {
                id: null,
                tagTitle: null,
                colors: null,
                createTime: null,
                remark: null
              }
            }).finally(() => {
              this.submitLoading = false
              this.form = {
                id: null,
                tagTitle: null,
                colors: null,
                createTime: null,
                remark: null
              }
            })
          } else {
            addTag(this.form).then(response => {
              this.$message.success(
                this.$t('common.addSuccess'),
                3
              )
              this.open = false
              this.$emit('ok')
              this.form = {
                id: null,
                tagTitle: null,
                colors: null,
                createTime: null,
                remark: null
              }
            }).finally(() => {
              this.submitLoading = false
              this.form = {
                id: null,
                tagTitle: null,
                colors: null,
                createTime: null,
                remark: null
              }
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.upload-image-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    max-width: 100%;
    max-height: 100%;
  }
}

.upload-mask {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  border-radius: 4px;
}

.avatar-uploader {
  :deep(.ant-upload-select-picture-card) {
    width: 104px;
    height: 104px;
  }

  :deep(.ant-upload-select-picture-card:hover) {
    border-color: #1890ff;
  }
}
</style>
